import type { FC } from 'react';

import type { IconProps } from './type';

export const AddCurrencyFilledIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height={23}
      width={22}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.213.179c-1.482 0-2.88.289-4.195.866a10.88 10.88 0 0 0-3.433 2.357 11.13 11.13 0 0 0-2.31 3.504 10.903 10.903 0 0 0-.85 4.281c0 1.512.284 2.939.85 4.281a11.129 11.129 0 0 0 2.31 3.504 10.88 10.88 0 0 0 3.433 2.357c1.315.578 2.713.866 4.195.866 1.482 0 2.88-.288 4.195-.866a10.88 10.88 0 0 0 3.433-2.357 11.13 11.13 0 0 0 2.31-3.504c.566-1.342.849-2.769.849-4.281 0-1.512-.283-2.939-.849-4.281a11.13 11.13 0 0 0-2.31-3.504 10.88 10.88 0 0 0-3.433-2.357A10.317 10.317 0 0 0 11.213.18Zm0 4.587c.333 0 .616.123.849.369.233.246.35.53.35.854v3.975h3.845c.316 0 .595.119.836.357.242.238.362.526.362.866 0 .34-.12.629-.362.866-.241.238-.52.357-.836.357H12.41v3.924c0 .323-.116.608-.35.854-.232.246-.515.37-.848.37-.333 0-.616-.124-.849-.37a1.205 1.205 0 0 1-.35-.854V12.41H6.12c-.316 0-.595-.119-.836-.357a1.17 1.17 0 0 1-.363-.866c0-.34.121-.628.363-.866.24-.238.52-.357.836-.357h3.895V5.989c0-.323.117-.608.35-.854.233-.246.516-.37.849-.37Z"
        fill="#0DD39C"
      />
    </svg>
  );
};
